import { Box, Paper, Typography, Button, Divider } from "@mui/material";
import { useOrderContext } from "contexts/OrderContext";
import { useRTL } from "hooks/isRTL";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import CustomSnackbar from "Components/shared/CustomSnackbar";

const DriversLocations = ({
  drivers = [],
  currentDriver,
  setCurrentDriver,
}) => {
  const { assignDriver, orderDetails } = useOrderContext();
  const navigate = useNavigate();
  const { t } = useRTL();
  const [snackbarDetails, setSnackbarDetails] = useState({
    message: "",
    severity: "error",
  });

  const handleAssignOrder = async (driverId) => {
    try {
      const response = await assignDriver(orderDetails.id, driverId);
      console.log("Assign Order Response:", response);

      navigate(-1);
    } catch (error) {
      const apiError = error?.response?.data;
      const rawMessage = apiError?.message;
      const normalizedMessage =
        typeof rawMessage === "string"
          ? rawMessage
              .replace(/_/g, " ")
              .replace(/([a-z])([A-Z])/g, "$1 $2")
              .trim()
          : rawMessage;
      const errorMessage =
        apiError?.errorCode === 29
          ? normalizedMessage || "Insufficient wallet balance"
          : normalizedMessage || "Failed to assign driver.";

      setSnackbarDetails({ message: errorMessage, severity: "error" });
      console.error("Failed to assign driver:", error);
    }
  };

  if (!drivers.length) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "90vh",
          textAlign: "center",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <Typography variant="h6" color="text.secondary">
          {t("nodriversavailableatthemoment")}
        </Typography>
        <Button
          variant="contained"
          onClick={() => navigate(-1)}
          sx={{ backgroundColor: "#2A3467" }}
        >
          {t("goBack")}
        </Button>
      </Box>
    );
  }

  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <Divider />
        {drivers.map((driver) => (
          <Paper
            onClick={() => setCurrentDriver(driver)}
            key={driver.id}
            sx={{
              padding: "1rem",
              display: "flex",
              flexDirection: "column",
              gap: "0.5rem",
              backgroundColor:
                currentDriver?.id === driver.id ? "#d1cfcf" : "white",
              cursor: "pointer",
              "&:hover": {
                backgroundColor:
                  currentDriver?.id === driver.id ? "#d1cfcf" : "#f4f4f4",
              },
            }}
          >
            {/* Driver Name */}
            <Typography variant="h2" sx={{ fontWeight: "bold" }}>
              {driver.fullName}
            </Typography>

            {/* Driver Phone */}
            <Typography variant="body1" color="text.black">
              {t("phone")}: {driver.phoneNumber}
            </Typography>

            {/* Distance */}
            <Typography
              variant="body1"
              color="text.black"
              sx={{
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              {t("distance")} :
              {(typeof driver.distance === "number" && !isNaN(driver.distance)
                ? (driver.distance / 1000).toFixed(2)
                : "0")}
              {" "}{t("km")}
            </Typography>

            {/* Assign Order Button */}
            <Button
              variant="contained"
              sx={{
                marginTop: "0.5rem",
                alignSelf: "flex-start",
                backgroundColor: "#2A3467",
              }}
              onClick={() => handleAssignOrder(driver.driverId)}
            >
              {t("assignOrder")}
            </Button>
          </Paper>
        ))}
      </Box>
      <CustomSnackbar
        message={snackbarDetails.message}
        severity={snackbarDetails.severity}
        onClose={() => setSnackbarDetails({ message: "", severity: "error" })}
      />
    </>
  );
};

export default DriversLocations;
